module.exports = __webpack_public_path__ + "img/laason_des.cb09de4f.jpg";